export const CONTACT_LIST_FETCH = 'CONTACT_LIST_FETCH';
export const CONTACT_LIST_SUCCESS = 'CONTACT_LIST_SUCCESS';
export const CONTACT_LIST_FAILURE = 'CONTACT_LIST_FAILURE';

export const DELETE_CONTACT_FETCH = 'DELETE_CONTACT_FETCH';
export const DELETE_CONTACT_SUCCESS = 'DELETE_CONTACT_SUCCESS';
export const DELETE_CONTACT_FAILURE = 'DELETE_CONTACT_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/ContactList/actionTypes.js